import { Fragment, useState } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputTime from "../../helpers/InputTime";
import { Link } from "react-router-dom";
import InputText from "../../helpers/InputText";
import InputCombo from "../../helpers/InputCombo";
import InputDateTime from "../../helpers/InputDateTime";


function HourEditE(props)
{

       
    const [errTab, setErrTab] = useState([]);  //z info od serwera..
    const [view,setView] = useState(props.view);

    var current_date = new Date();
    
    const [row, setRow] = useState( {
        dateTime: formatDateWithTime(current_date),
        type: 'W',
    } );

    const [title, setTitle] = useState(props.title);

   
    function formatDateWithTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
      
        return `${hours}:${minutes}:${seconds}`;
      }    
   

    const valChangeListener = (filedName, val, correct, msg) => {
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }  


    const goChange = () => {
        setView("dialog");    
    }

    const closeDialog = () => {       
        setView('link');
        
    }

    const saveTab = (operacja) => {

                setView('link');
 
                props.mainView.setProgress(-2);

                let send = ({
                    dzien_godzina:row.dateTime,
                    operacja:operacja,
                });
        
              
                fetch( Config.url + '/rest,emp_register_me', {
                    method: 'POST', 
                    body: JSON.stringify(send), 
                    headers: {
                        'Content-Type': 'application/json',                    
                        'X-Api-Key': props.userData.apiKey,
                        '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                        '_p_dziecko_id_': props.userData.p_dziecko_id,
                        '_sec_key_': Config.genXKey() ,
                    }
                 })
                 .then(res => res.json() )
                 .then(res => { 
        
                            props.mainView.setProgress(-1);        
                            if(res.status == undefined)
                            {
                                props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                            }else
                            if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                            {
                                props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                            }else    
                            {
                                ///   
                                props.onSucess();    
                                setRow(null);                                         
                            }
                 } )
                 .catch(err => {          
                            props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                            props.mainView.setProgress(-1);
                 });
                           
        
             
           
    }


 
    if(row===null)    
    {   
        setRow( {...row, ['dateTime']:formatDateWithTime(current_date),  ["dateTime_valid"]:'correct' } );        
    }
 
    
 


    var dlg = null;

        if(view == 'dialog')
        {
           

            dlg = <div className="dlg_window dlg_type_x shadowx">
                    <div className="dlg_title">{title}</div>            

                    <div className="dlg_msg">
                        
                        
                        <div>
                           
                        </div>

                            <div className="form_tab">                                

                                <div className="form_control">
                                    <div className="fieldName">Czas zdarzenia </div>
                                    <InputTime  value={row.dateTime} err={errTab}  valChange={valChangeListener}  name="dateTime" placeholder={"Dzień: "} className=' w250 ' req='1'   />
                                </div>

                               

                            </div>


                    </div>

                    <div className="dlg_btn dlg_btn_mobile">
                          <div className="btn btn_in" atr-type="save" onClick={()=>saveTab('I')}>Wejście</div>
                          
                          <div className="btn btn_out" atr-type="save" onClick={()=>saveTab('O')}>Wyjście</div>
                          
                          <div className="btn btn_back" atr-type="cancel" onClick={closeDialog}>Anuluj</div>
                    </div>
            </div>
        }

        if(view == 'link')
        {
            return (
                <div className="btn" onClick={goChange}  v="new" t='W' id="-1"  >Dodaj wejście/wyjście</div>
            )
        }

     
    

 
    
    var defText = '';
    if(defText.length < 1) defText = "---";
    
    return (
        <td className={props.className}>            
             <span onClick={goChange}>{defText}</span>
             {dlg}
             {props.children}
        </td>
    )
}

export default HourEditE;
